"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInquiryOrderFormEditViewModel = instanceOfInquiryOrderFormEditViewModel;
exports.InquiryOrderFormEditViewModelFromJSON = InquiryOrderFormEditViewModelFromJSON;
exports.InquiryOrderFormEditViewModelFromJSONTyped = InquiryOrderFormEditViewModelFromJSONTyped;
exports.InquiryOrderFormEditViewModelToJSON = InquiryOrderFormEditViewModelToJSON;
exports.InquiryOrderFormEditViewModelToJSONTyped = InquiryOrderFormEditViewModelToJSONTyped;
/**
 * Check if a given object implements the InquiryOrderFormEditViewModel interface.
 */
function instanceOfInquiryOrderFormEditViewModel(value) {
    return true;
}
function InquiryOrderFormEditViewModelFromJSON(json) {
    return InquiryOrderFormEditViewModelFromJSONTyped(json, false);
}
function InquiryOrderFormEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'iofFormNo': json['iofFormNo'] == null ? undefined : json['iofFormNo'],
        'iofOrgId': json['iofOrgId'] == null ? undefined : json['iofOrgId'],
        'oName': json['oName'] == null ? undefined : json['oName'],
        'iofWebSiteNo': json['iofWebSiteNo'] == null ? undefined : json['iofWebSiteNo'],
        'iofFormId': json['iofFormId'] == null ? undefined : json['iofFormId'],
        'iofMemberNo': json['iofMemberNo'] == null ? undefined : json['iofMemberNo'],
        'iofName': json['iofName'] == null ? undefined : json['iofName'],
        'iofCell': json['iofCell'] == null ? undefined : json['iofCell'],
        'iofEmail': json['iofEmail'] == null ? undefined : json['iofEmail'],
        'iofAddress': json['iofAddress'] == null ? undefined : json['iofAddress'],
        'iofMemoDesc': json['iofMemoDesc'] == null ? undefined : json['iofMemoDesc'],
        'iofUseStatus': json['iofUseStatus'] == null ? undefined : json['iofUseStatus'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
        'iofDelFlag': json['iofDelFlag'] == null ? undefined : json['iofDelFlag'],
        'iofUpDate': json['iofUpDate'] == null ? undefined : json['iofUpDate'],
        'iofProductsTotal': json['iofProductsTotal'] == null ? undefined : json['iofProductsTotal'],
        'iofCouponDiscount': json['iofCouponDiscount'] == null ? undefined : json['iofCouponDiscount'],
        'iofFinalTotal': json['iofFinalTotal'] == null ? undefined : json['iofFinalTotal'],
        'iofPackingWay': json['iofPackingWay'] == null ? undefined : json['iofPackingWay'],
        'iofPickupMethod': json['iofPickupMethod'] == null ? undefined : json['iofPickupMethod'],
        'iofPayStatus': json['iofPayStatus'] == null ? undefined : json['iofPayStatus'],
        'iofOrOrderId': json['iofOrOrderId'] == null ? undefined : json['iofOrOrderId'],
        'iofCancelMemo': json['iofCancelMemo'] == null ? undefined : json['iofCancelMemo'],
    };
}
function InquiryOrderFormEditViewModelToJSON(json) {
    return InquiryOrderFormEditViewModelToJSONTyped(json, false);
}
function InquiryOrderFormEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'iofFormNo': value['iofFormNo'],
        'iofOrgId': value['iofOrgId'],
        'oName': value['oName'],
        'iofWebSiteNo': value['iofWebSiteNo'],
        'iofFormId': value['iofFormId'],
        'iofMemberNo': value['iofMemberNo'],
        'iofName': value['iofName'],
        'iofCell': value['iofCell'],
        'iofEmail': value['iofEmail'],
        'iofAddress': value['iofAddress'],
        'iofMemoDesc': value['iofMemoDesc'],
        'iofUseStatus': value['iofUseStatus'],
        'useStatus': value['useStatus'],
        'iofDelFlag': value['iofDelFlag'],
        'iofUpDate': value['iofUpDate'],
        'iofProductsTotal': value['iofProductsTotal'],
        'iofCouponDiscount': value['iofCouponDiscount'],
        'iofFinalTotal': value['iofFinalTotal'],
        'iofPackingWay': value['iofPackingWay'],
        'iofPickupMethod': value['iofPickupMethod'],
        'iofPayStatus': value['iofPayStatus'],
        'iofOrOrderId': value['iofOrOrderId'],
        'iofCancelMemo': value['iofCancelMemo'],
    };
}
